import React from 'react';
import { Link } from 'react-router-dom';

const TERRACOTTA = '#BC6C25';
const DEEP_MOSS  = '#283618';
const PAPER      = '#FCF9F2';

export const Footer = () => (
  <footer style={footerStyle}>
    <style>{`
      @media (max-width: 768px) {
        .footer-inner { padding-bottom: 90px !important; }
        /* Change align-items to center and set text-align center */
        .footer-main { 
          flex-direction: column !important; 
          align-items: center !important; 
          gap: 20px !important;
          text-align: center !important;
        }
        /* Ensure the right side takes full width and centers children */
        .footer-right-side {
          align-items: center !important;
          text-align: center !important;
        }
        /* Ensure motto is centered on mobile */
        .footer-motto {
          text-align: center !important;
        }
      }
    `}</style>

    <div style={containerStyle} className="footer-inner">

      <div style={mainRow} className="footer-main">

        {/* Logo */}
        <Link to="/" style={logoLinkStyle} aria-label="SayCiao.school — home">
          <svg width="22" height="22" viewBox="0 0 64 64" fill="none" style={{ flexShrink: 0 }}>
            <rect width="64" height="64" rx="14" fill="#F7F4EF" stroke="rgba(0,0,0,0.04)" strokeWidth="1"/>
            <clipPath id="flag-footer"><rect width="64" height="64" rx="14"/></clipPath>
            <rect x="0"    y="0" width="21.3" height="64" fill="#009246" opacity="0.18" clipPath="url(#flag-footer)"/>
            <rect x="42.6" y="0" width="21.4" height="64" fill="#CE2B37" opacity="0.28" clipPath="url(#flag-footer)"/>
            <rect x="10" y="32" width="6" height="6"  rx="3" fill="#BC6C25" opacity="0.45"/>
            <rect x="19" y="26" width="6" height="18" rx="3" fill="#BC6C25" opacity="0.7"/>
            <rect x="28" y="14" width="6" height="42" rx="3" fill="#BC6C25"/>
            <rect x="37" y="20" width="6" height="30" rx="3" fill="#BC6C25" opacity="0.7"/>
            <rect x="46" y="28" width="6" height="14" rx="3" fill="#BC6C25" opacity="0.45"/>
          </svg>
          <span style={logoWordmarkStyle}>
            <span style={logoSayStyle}>say</span>
            <span style={logoCiaoStyle}>ciao</span>
            <span style={logoDotStyle}>.</span>
            <span style={logoSchoolStyle}>school</span>
          </span>
        </Link>

        {/* Right side — Added class footer-right-side */}
        <div style={rightSide} className="footer-right-side">
          <a href="mailto:sayciao.school@outlook.com" style={emailStyle}>
            sayciao.school@outlook.com
          </a>
          <p style={mottoStyle} className="footer-motto">
            Find your own Italian voice, one conversation at a time.
          </p>
        </div>

      </div>

      <div style={bottomBar}>
        <p style={copyrightStyle}>© {new Date().getFullYear()} SayCiao.school</p>
        <Link to="/privacy" style={privacyStyle}>Privacy Policy</Link>
        <Link to="/terms" style={privacyStyle}>Terms of Service</Link>
        </div>

    </div>
  </footer>
);

// ─── Styles ───────────────────────────────────────────────────────────────────
const footerStyle = {
  backgroundColor: PAPER,
  borderTop: '1px solid rgba(40,54,24,0.06)',
  color: DEEP_MOSS,
  width: '100%',
  boxSizing: 'border-box',
  padding: '32px 5% 28px',
};

const containerStyle = { maxWidth: '1200px', margin: '0 auto' };

const mainRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '24px',
};

// Logo — matches Navbar editorial style
const logoLinkStyle     = { display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' };
const logoWordmarkStyle = { display: 'flex', alignItems: 'baseline', gap: 0 };
const logoSayStyle      = { fontFamily: "'Montserrat', sans-serif", fontSize: '0.72rem', fontWeight: 600, letterSpacing: '1px', color: DEEP_MOSS };
const logoCiaoStyle     = { fontFamily: "'Montserrat', sans-serif", fontSize: '0.72rem', fontWeight: 600, letterSpacing: '1px', color: TERRACOTTA };
const logoDotStyle      = { fontFamily: "'Montserrat', sans-serif", fontSize: '0.72rem', fontWeight: 300, color: TERRACOTTA, opacity: 0.5 };
const logoSchoolStyle   = { fontFamily: "'Montserrat', sans-serif", fontSize: '0.72rem', fontWeight: 300, letterSpacing: '1px', color: DEEP_MOSS, opacity: 0.85 };

const rightSide = { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '5px' };

const emailStyle = {
  fontSize: '0.72rem',
  color: TERRACOTTA,
  textDecoration: 'none',
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 600,
  letterSpacing: '0.3px',
  borderBottom: '1px solid rgba(188,108,37,0.25)',
  paddingBottom: '1px',
};

const mottoStyle = {
  fontSize: '0.75rem',
  fontFamily: "'Cormorant Garamond', serif",
  fontStyle: 'italic',
  color: DEEP_MOSS,
  opacity: 0.75,
  margin: 0,
  textAlign: 'right',
  letterSpacing: '0.2px',
};

const bottomBar = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '16px',
  borderTop: '1px solid rgba(40,54,24,0.05)',
};

const copyrightStyle = {
  fontSize: '0.7rem',
  color: DEEP_MOSS,
  opacity: 0.6,
  margin: 0,
  fontFamily: "'Montserrat', sans-serif",
};

const privacyStyle = {
  fontSize: '0.7rem',
  color: DEEP_MOSS,
  opacity: 0.7,
  fontFamily: "'Montserrat', sans-serif",
  textDecoration: 'none',
  borderBottom: '1px solid rgba(40,54,24,0.15)',
  paddingBottom: '1px',
};

export default Footer;